import { render, staticRenderFns } from "./ListRecentSimulations.vue?vue&type=template&id=2a118c8c&"
import script from "./ListRecentSimulations.vue?vue&type=script&lang=js&"
export * from "./ListRecentSimulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports